var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.corrections.length)?_c('div',{staticClass:"keyword-corrections"},[_vm._v("\n  Did you mean: \n  "),_vm._l((_vm.corrections),function(text){return _c('span',{key:text,staticClass:"query-link",on:{"click":function($event){return _vm.handleLinkClick(text)}}},[_vm._v(_vm._s(text))])})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }